import React from 'react'

import {
    Dialog,
    Typography,
    Box,
    TextField,
    Button,
    DialogActions,
    useTheme,
} from '@material-ui/core'
import { typographyStyle } from '../../../theme/typographyStyle'

interface VoidInvoiceDialogProps {
    voidReason: string
    onVoidInvoice: (invoiceId: string, reason: string) => void
    setVoidReason: (reason: string) => void
    open: boolean
    onClose: () => void
    invoiceId: string
}

export const VoidInvoiceDialog: React.FC<VoidInvoiceDialogProps> = ({
    voidReason,
    setVoidReason,
    open,
    onClose,
    onVoidInvoice,
    invoiceId,
}) => {
    const theme = useTheme()
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: {
                    borderRadius: 16,
                    position: 'absolute',
                    top: 90,
                    left: 90,
                },
            }}
        >
            <Box
                style={{
                    padding: theme.spacing(3),
                }}
            >
                <Typography
                    style={{
                        ...typographyStyle(theme.typography.h6),
                        fontWeight: 'bold',
                        color: theme.palette.error.main,
                        marginBottom: theme.spacing(2),
                    }}
                >
                    Void Invoice
                </Typography>
                <TextField
                    fullWidth
                    label="Reason for voiding"
                    value={voidReason}
                    onChange={(e) => setVoidReason(e.target.value)}
                    variant="outlined"
                    required
                />
            </Box>
            <DialogActions>
                <Button
                    onClick={onClose}
                    style={{ marginRight: theme.spacing(1) }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => onVoidInvoice(invoiceId, voidReason)}
                    color="secondary"
                    disabled={!voidReason}
                    variant="contained"
                >
                    Confirm Void
                </Button>
            </DialogActions>
        </Dialog>
    )
}
